import {Component, Input} from '@angular/core';
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import { FormControlValidators, FormControlASyncValidators } from 'app/models/validators/validator';
import {BaseModalComponent} from "app/views/modal/base_modal.component";
import {UserProvider, UserAllow} from "app/models/acl.model";
import { debounceTime} from "rxjs/operators";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HelperService} from "../../lib/helper.service";
import {SupportService} from "../../support/support/support.service";
import {BaseFormGroup} from "../../models/form";

@Component({
	template: `
		<base-modal
			[title]="title"
			[isLoading]="isLoading"
			[isBtnOkActive]="isBtnOkActive"
			(onOk)="ok()">
			<form [formGroup]="form">
				<div class="form-group">
					<label for="name">email</label>
					<input type="text" class="form-control" id="email" formControlName="email"
						   [formErrorIndicator]="email"
					/>
				</div>

				<a role="button" class="btn btn-link" (click)="addAllow()">
					<i class="fa fa-fw fa-plus"></i>
				</a>
				
				<div formGroupName="allows">
					<table class="table">
						<thead>
							<tr>
								<th></th>
								<th>provider</th>
								<th>role</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let allow of allows.controls; let i=index">
								<td>
									<div class="form-group"  formGroupName="{{i}}">
										<a role="button" class="btn btn-link" (click)="deleteRole(allow)">
											<i class="fa fa-fw fa-trash"></i>
										</a>
									</div>
								</td>
								
								<td>
									<div class="form-group" formGroupName="{{i}}">
										<select class="form-control" formControlName="providerName">
											<option *ngFor="let p of [''].concat(providerNameList).sort()" value="{{ p }}" [selected]="providerName === p">
												{{ p }}
											</option>
										</select>
									</div>
								</td>
								
								<td>
									<div class="form-group" formGroupName="{{i}}">
										<select class="form-control" formControlName="role">
											<option *ngFor="let r of ['', 'adminPromocodes'].concat(roleNameList).sort()" value="{{ r }}" [selected]="role === r">
												{{ r }}
											</option>
										</select>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</form>
		</base-modal>
	`
})
export class RoleFormComponent extends BaseModalComponent {
	@Input() providerNameList: string[] = [];
	@Input() roleNameList: string[] = [];
	
	
	isBtnOkActive = false;
	
	form = new BaseFormGroup({
		_id: new FormControl(''),
		email: new FormControl('', [
			FormControlValidators.required(),
			FormControlValidators.email(),
		]),
		allows: new FormArray([]),
		userId: new FormControl(''),
	});
	
	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public supportService: SupportService,
		public asyncValidators: FormControlASyncValidators
	) {
		super(activeModal);
		
		const me = this;
		
		me.email.setAsyncValidators(
			this.asyncValidators.emailExists()
		)
	}
	
	get email()  { return this.form.get('email');               }
	
	get allows() { return this.form.get('allows') as FormArray; }
	
	// Это не магия, это API!
	ok() {
		const me = this;
		
		if (me.form.status === 'VALID') {
			me.activeModal.close(
				me.form.value
			);
			
			return;
		}
	}
	
	
	deleteRole(allow: FormControl) {
		const idx = this.allows.value.findIndex(a => a.role === allow.get('role').value);
		if (idx === -1) {
			return ;
		}
		
		this.allows.removeAt(idx);
	}
	
	
	getNewAllowGroup(providerName: string = '', role: string = 'guest') {
		return new FormGroup({
			providerName: new FormControl(providerName),
			role: new FormControl(role, [
				FormControlValidators.required()
			]),
		})
	}
	
	
	addAllow() {
		this.allows.push(
			this.getNewAllowGroup()
		);
	}
	
	// Что это за Кончита Вурст?!?!?!
	setRole(role) {
		this.form.patchValue(role);
		
		const allows = this.form.get('allows') as FormArray;
		role.allows.forEach(a => {
			allows.push(
				this.getNewAllowGroup(a.providerName, a.role)
			)
		});
	}
}
